import { Directive } from '@angular/core';

@Directive({
  selector: '[fInnerErrorActions]',
  standalone: false
})
export class FireflyInnerErrorDirective {}
